// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockHead__rhr5i {
  min-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle___T0pe {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__gm25J {
  display: grid;
  grid-template-columns: 140px 1fr minmax(350px, 450px);
  grid-template-rows: 22px 1fr auto;
  gap: 25px;
  padding: 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}
@media (max-width: 1700px) {
  .blockContainer__gm25J {
    grid-template-columns: 140px 1fr minmax(350px, 400px);
  }
}
@media (max-width: 1500px) {
  .blockContainer__gm25J {
    grid-template-columns: 140px 1fr 320px;
  }
}
@media (max-width: 999px) {
  .blockContainer__gm25J {
    grid-template-columns: 140px 1fr;
    grid-template-rows: 22px 1fr 160px auto;
  }
}
@media print {
  .blockContainer__gm25J {
    grid-template-rows: 22px 1fr auto;
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
}

.simpleBlock__WQmhW {
  grid-template-rows: 22px 1fr;
}
@media (max-width: 999px) {
  .simpleBlock__WQmhW {
    grid-template-rows: 22px 1fr 160px;
  }
}
@media print {
  .simpleBlock__WQmhW {
    grid-template-rows: 22px auto auto;
  }
}

.networkExtraBlock___uTaW {
  grid-template-rows: auto 1fr auto;
}

.translateBlock__Uqv_3 {
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.translateLang__E31Z6 {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-surface);
  text-transform: uppercase;
}

.actionItemHead__B_Nq_ {
  grid-area: 1/1/2/3;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.disclaimer__m6i3w {
  font-size: 14px;
  line-height: 14px;
  color: var(--tables-primary-row-text-main);
  flex: 1 1 100%;
  padding: 10px;
  background-color: var(--notifications-info-surface);
}

.urgency1__QR0gM {
  background-color: var(--labels-filled-surface-standard);
}

.urgency2___QSyi {
  background-color: var(--labels-filled-surface-high);
}

.urgency3__jzC9Z {
  background-color: var(--labels-filled-surface-critical);
}

.extraInformation__jXHV4 {
  grid-area: 2/1/3/2;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.mainInformation__xSncr {
  grid-area: 2/2/3/3;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.infoActions__uM40_ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-area: 3/1/4/3;
}
@media (max-width: 999px) {
  .infoActions__uM40_ {
    grid-area: 4/1/4/3;
  }
}

.galleryBlock__WHnFV {
  grid-area: 1/3/4/3;
}
@media (max-width: 999px) {
  .galleryBlock__WHnFV {
    grid-area: 3/1/3/3;
  }
}

.simpleGalleryBlock__ALbhP {
  grid-area: 1/3/3/3;
}
@media (max-width: 999px) {
  .simpleGalleryBlock__ALbhP {
    grid-area: 3/1/3/3;
  }
}

.link__doG5s {
  font-size: 11px;
  line-height: 13px;
  color: var(--buttons-surface);
  text-align: right;
  text-transform: uppercase;
  text-decoration: none;
}
@media (min-width: 1600px) {
  .link__doG5s {
    white-space: nowrap;
  }
}
@media print {
  .link__doG5s {
    overflow: hidden;
    height: 0;
  }
}

.copyIcon__cRsnX {
  height: 14px;
  cursor: pointer;
}
@media print {
  .copyIcon__cRsnX {
    overflow: hidden;
    height: 0;
  }
}

.aiDetailsInfoTooltip__cLYNg {
  max-width: 400px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}

.skeletonStatusLabel__RAZTb {
  height: 22px;
  width: 155px;
}

.skeletonLabel__Dm4Be {
  height: 22px;
  width: 45px;
}

.skeletonDevice__jYaw_ {
  height: 120px;
}

.skeletonInfoFieldLabel__fNcyp {
  height: 14px;
  width: 90px;
}

.skeletonInfoField__Avyfe {
  height: 35px;
}

.skeletonButton__ZxBEr {
  height: 35px;
}

.skeletonGallery__gjKy4 {
  max-height: 360px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/TechnicalInfoAI/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,qDAAA;EACA,iCAAA;EACA,SAAA;EACA,aAAA;EACA,qDAAA;EAEA,mCAAA;AA1EF;AA4EE;EAVF;IAWI,qDAAA;EAzEF;AACF;AA2EE;EAdF;IAeI,sCAAA;EAxEF;AACF;AA0EE;EAlBF;IAmBI,gCAAA;IACA,uCAAA;EAvEF;AACF;AAyEE;EAvBF;IAwBI,iCAAA;IACA,6BAAA;IACA,gBAAA;IACA,UAAA;EAtEF;AACF;;AAyEA;EACE,4BAAA;AAtEF;AAwEE;EAHF;IAII,kCAAA;EArEF;AACF;AAuEE;EAPF;IAQI,kCAAA;EApEF;AACF;;AAuEA;EACE,iCAAA;AApEF;;AAuEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AApEF;;AAuEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;AApEF;;AAuEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AApEF;;AAuEA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,mDAAA;AApEF;;AAuEA;EACE,uDAAA;AApEF;;AAsEA;EACE,mDAAA;AAnEF;;AAqEA;EACE,uDAAA;AAlEF;;AAqEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAlEF;;AAqEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAlEF;AAoEE;EANF;IAOI,kBAAA;EAjEF;AACF;;AAoEA;EACE,kBAAA;AAjEF;AAmEE;EAHF;IAII,kBAAA;EAhEF;AACF;;AAmEA;EACE,kBAAA;AAhEF;AAkEE;EAHF;IAII,kBAAA;EA/DF;AACF;;AAkEA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AA/DF;AAiEE;EARF;IASI,mBAAA;EA9DF;AACF;AAgEE;EAZF;IAaI,gBAAA;IACA,SAAA;EA7DF;AACF;;AAgEA;EACE,YAAA;EACA,eAAA;AA7DF;AA+DE;EAJF;IAKI,gBAAA;IACA,SAAA;EA5DF;AACF;;AA+DA;EACE,gBAAA;EA/LA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAoIF;;AA2DA;EACE,YAAA;EACA,YAAA;AAxDF;;AA2DA;EACE,YAAA;EACA,WAAA;AAxDF;;AA2DA;EACE,aAAA;AAxDF;;AA2DA;EACE,YAAA;EACA,WAAA;AAxDF;;AA2DA;EACE,YAAA;AAxDF;;AA2DA;EACE,YAAA;AAxDF;;AA2DA;EACE,iBAAA;AAxDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockHead {\n  min-height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  display: grid;\n  grid-template-columns: 140px 1fr minmax(350px, 450px);\n  grid-template-rows: 22px 1fr auto;\n  gap: 25px;\n  padding: 25px;\n  background: var(--tables-primary-row-surface-default);\n\n  box-shadow: var(--table-box-shadow);\n\n  @media (max-width: 1700px) {\n    grid-template-columns: 140px 1fr minmax(350px, 400px);\n  }\n\n  @media (max-width: 1500px) {\n    grid-template-columns: 140px 1fr 320px;\n  }\n\n  @media (max-width: 999px) {\n    grid-template-columns: 140px 1fr;\n    grid-template-rows: 22px 1fr 160px auto;\n  }\n\n  @media print {\n    grid-template-rows: 22px 1fr auto;\n    background-color: transparent;\n    box-shadow: none;\n    padding: 0;\n  }\n}\n\n.simpleBlock {\n  grid-template-rows: 22px 1fr;\n\n  @media (max-width: 999px) {\n    grid-template-rows: 22px 1fr 160px;\n  }\n\n  @media print {\n    grid-template-rows: 22px auto auto;\n  }\n}\n\n.networkExtraBlock {\n  grid-template-rows: auto 1fr auto;\n}\n\n.translateBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.translateLang {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-surface);\n  text-transform: uppercase;\n}\n\n.actionItemHead {\n  grid-area: 1 / 1 / 2 / 3;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.disclaimer {\n  font-size: 14px;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-main);\n  flex: 1 1 100%;\n  padding: 10px;\n  background-color: var(--notifications-info-surface);\n}\n\n.urgency1 {\n  background-color: var(--labels-filled-surface-standard);\n}\n.urgency2 {\n  background-color: var(--labels-filled-surface-high);\n}\n.urgency3 {\n  background-color: var(--labels-filled-surface-critical);\n}\n\n.extraInformation {\n  grid-area: 2 / 1 / 3 / 2;\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.mainInformation {\n  grid-area: 2 / 2 / 3 / 3;\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.infoActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  grid-area: 3 / 1 / 4 / 3;\n\n  @media (max-width: 999px) {\n    grid-area: 4 / 1 / 4 / 3;\n  }\n}\n\n.galleryBlock {\n  grid-area: 1 / 3 / 4 / 3;\n\n  @media (max-width: 999px) {\n    grid-area: 3 / 1 / 3 / 3;\n  }\n}\n\n.simpleGalleryBlock {\n  grid-area: 1 / 3 / 3 / 3;\n\n  @media (max-width: 999px) {\n    grid-area: 3 / 1 / 3 / 3;\n  }\n}\n\n.link {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--buttons-surface);\n  text-align: right;\n  text-transform: uppercase;\n  text-decoration: none;\n\n  @media (min-width: 1600px) {\n    white-space: nowrap;\n  }\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.copyIcon {\n  height: 14px;\n  cursor: pointer;\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.aiDetailsInfoTooltip {\n  max-width: 400px;\n  @include tooltip;\n}\n\n.skeletonStatusLabel {\n  height: 22px;\n  width: 155px;\n}\n\n.skeletonLabel {\n  height: 22px;\n  width: 45px;\n}\n\n.skeletonDevice {\n  height: 120px;\n}\n\n.skeletonInfoFieldLabel {\n  height: 14px;\n  width: 90px;\n}\n\n.skeletonInfoField {\n  height: 35px;\n}\n\n.skeletonButton {\n  height: 35px;\n}\n\n.skeletonGallery {\n  max-height: 360px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockHead": `blockHead__rhr5i`,
	"blockTitle": `blockTitle___T0pe`,
	"blockContainer": `blockContainer__gm25J`,
	"simpleBlock": `simpleBlock__WQmhW`,
	"networkExtraBlock": `networkExtraBlock___uTaW`,
	"translateBlock": `translateBlock__Uqv_3`,
	"translateLang": `translateLang__E31Z6`,
	"actionItemHead": `actionItemHead__B_Nq_`,
	"disclaimer": `disclaimer__m6i3w`,
	"urgency1": `urgency1__QR0gM`,
	"urgency2": `urgency2___QSyi`,
	"urgency3": `urgency3__jzC9Z`,
	"extraInformation": `extraInformation__jXHV4`,
	"mainInformation": `mainInformation__xSncr`,
	"infoActions": `infoActions__uM40_`,
	"galleryBlock": `galleryBlock__WHnFV`,
	"simpleGalleryBlock": `simpleGalleryBlock__ALbhP`,
	"link": `link__doG5s`,
	"copyIcon": `copyIcon__cRsnX`,
	"aiDetailsInfoTooltip": `aiDetailsInfoTooltip__cLYNg`,
	"skeletonStatusLabel": `skeletonStatusLabel__RAZTb`,
	"skeletonLabel": `skeletonLabel__Dm4Be`,
	"skeletonDevice": `skeletonDevice__jYaw_`,
	"skeletonInfoFieldLabel": `skeletonInfoFieldLabel__fNcyp`,
	"skeletonInfoField": `skeletonInfoField__Avyfe`,
	"skeletonButton": `skeletonButton__ZxBEr`,
	"skeletonGallery": `skeletonGallery__gjKy4`
};
module.exports = ___CSS_LOADER_EXPORT___;
